import React, {useEffect, useState} from "react";
import { Layout, PageHeader, Space, Button, Table,Radio, Avatar, Divider, DatePicker, Row, Col, Grid, Collapse, Empty } from "antd";
import moment from "moment";
import Spinner from "../../../components/Layout/Spinner";
import DashboardService from "../../../services/DashboardService";
import OverviewCard from "../../../components/Card/OverviewKpiCard";
import TipDetails from "./TipDetails";
import ServerTips from "./serverTips";

const { Content } = Layout;
const {useBreakpoint} = Grid
const { Panel } = Collapse;

const Tips = () => {
  const [isLoading, setLoading] = useState(false);
  const [singleItem, setSingleItem] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf('week').format('DD-MM-YYYY'));
  const [toDate, setToDate] = useState(moment().endOf('week').format('DD-MM-YYYY'));
  const [size, setSize] = useState('week');
  const [posData, setPosData] = useState("");
  const [deliveryData, setDeliveryData] = useState("");
  const [pickupData, setPickupData] = useState("");
  const screens = useBreakpoint();

 
  useEffect(() => {
    getPosTips();
    getDelivTips();
    getPickupTips();
  }, [toDate, fromDate]);

  const getPosTips = async () => {
    setLoading(true)
    const posTips = await DashboardService.getPosTips(fromDate, toDate);
    setPosData(posTips);
    setLoading(false)
  };
  const getDelivTips = async () => {
    const delData = await DashboardService.getDeliveryTips(fromDate, toDate);
    setDeliveryData(delData)
  }
  const getPickupTips = async () => {
    const pData = await DashboardService.getPickupTips(fromDate, toDate);
    setPickupData(pData)
  }

  const columnsPickup = [
    {
      title: "Order ID",
      dataIndex: "order_num",
      key: "order_num",
      render: (_, record) => {
        return (
          <div>
            <div  className="name_text">
              {record.order_num}
            </div>
          </div>
        );
      },
    },
    {
        title: "Card Tips",
        dataIndex: "card_tip",
        key: "card_tip",
        render: (_, record) => {
          return (
            <div>
              <div  className="name_text">
                {record.card_tip}
              </div>
            </div>
          );
        },
      },]
  const columnsDelivery = [
    {
      title: "Driver Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div style={{display: 'flex'}}>
            <div  className="name_text">
            <span className="pr-24"><Avatar size={32} src={record?.photo_url} /></span>
              {record.name}
            </div>
          </div>
        );
      },
    },
    {
        title: "Card Tips",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div>
              <div  className="name_text">
                {record.total_tips}
              </div>
            </div>
          );
        },
      },
    ]
 
  const columns = [
    {
      title: "Server Name",
      dataIndex: "name",
      key: "name",
      width: "25%",
      render: (_, record) => {
        return (
          <div style={{display: 'flex'}}>
            <div  className="name_text">
            <span className="pr-24"><Avatar size={64} src={record?.photo_url} /></span>
              {record.name}
            </div>
          </div>
        );
      },
    },
    {
        title: "Cash Tips",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div>
              <div  className="name_text">
                {record.cash_tip}
              </div>
            </div>
          );
        },
      },
      {
        title: "Card Tips",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div>
              <div  className="name_text">
                {record.card_tip}
              </div>
            </div>
          );
        },
      },
      {
        title: "Total Tips",
        dataIndex: "total_tips",
        key: "total_tips",
        render: (_, record) => {
          return (
            <div>
              <div  className="name_text">
                {record.total_tips}
              </div>
            </div>
          );
        },
      },
  ];

  const showDetailsView=(value)=>{
    setShowDetails(value)
  }

  const onFilterDateChange = (date, dateString, field) => {
    if(field === 'starDate'){
      setFromDate(moment(dateString, 'MMM DD, YYYY'));
    } else {
      setToDate(moment(dateString, 'MMM DD, YYYY'));
    }
    setSize('');
  };
  const onPeriodChange = (e) => {
    setSize(e.target.value);
    setFromDate(moment().startOf(e.target.value).format('DD-MM-YYYY'));
    setToDate(moment().endOf(e.target.value).format('DD-MM-YYYY'))
  };

  const onReset = () => {
    setSize('week');
    setFromDate(moment().startOf('week').format('DD-MM-YYYY'));
    setToDate(moment().endOf('week').format('DD-MM-YYYY'))
  };

  return (
    <Layout className="u-page-layout tips-layout">
       {showDetails?
      (showDetails === 'pos' ?
      <ServerTips order={singleItem} setShowDetails ={showDetailsView}/>
      :
      <TipDetails order={singleItem} setShowDetails ={showDetailsView}/>
      ):
      <Content className="w-full page-padding">
        <Space direction="vertical" style={{ width: "100%" }}>
          <PageHeader
            title="Tips in POS"
            className={"page-header" + (!screens.md && " mobile-tips-pos-header")}
            extra={[
              <>
              {/* <div className="flex" style={{ border: size ? "0px" : "2px solid red"}}>
                <div className=""><DatePicker name="starDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, "starDate")} value={moment(fromDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <div className=""><DatePicker name="endDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, 'endDate')} value={moment(toDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <Button type={size ? "dashed" : "primary" } onClick={onReset}>Reset</Button>
              </div> */}
              <div>
               <Radio.Group value={size} onChange={onPeriodChange}>
                <Radio.Button value="week" className="pos-radio-button">Daily</Radio.Button>
                <Radio.Button value="month">Weekly</Radio.Button>
                <Radio.Button value="year" className="online-radio-button">Total</Radio.Button>
              </Radio.Group>
            </div>
            </>
            ]}
          />
           <div className="text-left flex flex_wrap p-1">
            <div>
              <OverviewCard title={`$ ${posData?.total_tips || 0}`} subTitle="Total Tips recieved" className="min_kpi_card_size"/>
            </div>
            <div>
              <OverviewCard title={`$ ${posData?.tips_recieved_by_card || 0}`} subTitle="Tips recieved via card" className="min_kpi_card_size"/>
            </div>
            <div>
              <OverviewCard title={`$ ${posData?.tips_recieved_in_cash || 0}`} subTitle="Tips recieved in cash" className="min_kpi_card_size"/>
            </div>
          </div>
          <div className="p-1">
            {screens.md?
            <Table
              columns={columns}
              dataSource={posData.tips_by_employees}
              className="discount-table"
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    setSingleItem(record);
                    setShowDetails('pos')
                  }, // click row
                };
              }}
            />
            :
            // posData.tips_by_employees?.length === 0 ?
            // <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            // :
            posData.tips_by_employees?.map((record) => (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={[""]}
                    expandIconPosition="end"
                    className="review-list-collapse"
                  >
                    <Panel
                      key="sales"
                      header={
                        <div className="flex">
                          <Avatar
                            shape="round"
                            size={50}
                            src={record?.logo_url}
                            style={{ marginRight: "20px" }}
                          />
                          <div className="item-name">{record?.name}</div>
                        </div>
                      }
                    >
                      <div className="flex space-between">
                        <div> Cash Tips </div>{" "}
                        <div> ${record?.cash_tip ?? 0}</div>{" "}
                      </div>
                      <div className="flex space-between">
                        <div> Card Tips </div>{" "}
                        <div> ${record?.card_tip ?? 0}</div>{" "}
                      </div>
                      <div className="flex space-between">
                        <div> Total Tips </div>{" "}
                        <div> ${record?.total_tips ?? 0}</div>{" "}
                      </div>
                    </Panel>
                  </Collapse>
                ))
                }
          </div>
          <Divider/>
          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
          <Col xs={24} md={11} lg={11}>
            <div >
              <PageHeader
                title="Tips in Delivery"
                className="page-header"
                extra={[]}
              />
                <OverviewCard title={`$ ${deliveryData?.total_tips || 0}`} subTitle="Total tips recieved" className="min_kpi_card_size"/>
                <Table
                columns={columnsDelivery}
                dataSource={deliveryData?.tips_by_employees}
                className="discount-table"
                onRow={(record) => {
                  return {
                    onClick: () => {
                      setSingleItem(record);
                      setShowDetails('delivery')
                    }, // click row
                  };
                }}
              />
            </div>
           </Col>
           <Col xs={24} md={2}  lg={2} style={{ textAlign: "center" }}>
              <Divider type="vertical"/>
              </Col>  
              <Col xs={24} md={11} lg={11}>
            <div >
              <PageHeader
                title="Tips in Pickup"
                className="page-header"
                extra={[
                ]}
              />
                <OverviewCard title={`$ ${pickupData?.total_tips || 0}`} subTitle="Total tips recieved" className="min_kpi_card_size"/>
                <Table
                columns={columnsPickup}
                dataSource={pickupData?.tips_by_employees}
                className="discount-table"
                // onRow={(record) => {
                //   return {
                //     onClick: () => {
                //       setSingleItem(record);
                //       setShowDetails('pickup')
                //     }, // click row
                //   };
                // }}
              />
            </div>
            </Col>
          </Row>
        </Space>
      </Content>
}
     
      {isLoading && <Spinner/>}
    </Layout>
  );
};

export default Tips;
